import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';

import withEnrollment from 'bundles/enroll-common/components/xdp/withEnrollment';
import type { PropsFromWithEnrollment } from 'bundles/enroll-common/components/xdp/withEnrollment';
import Naptime from 'bundles/naptimejs';
import CoursesV1 from 'bundles/naptimejs/resources/courses.v1';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/enroll-course';

type PropsFromCaller = {
  courseId: string;
  className?: string;
};

type PropsFromNaptime = {
  course: CoursesV1;
};

type PropsToComponent = PropsFromCaller & PropsFromNaptime & PropsFromWithEnrollment;

class LegacyCourseEnrollButton extends React.Component<PropsToComponent> {
  static contextTypes = {
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof LegacyCourseEnrollButton.contextTypes>;

  render() {
    const { course, enrollmentAvailableChoices, className } = this.props;

    const elClassName = classNames('rc-LegacyCourseEnrollButton', className);

    if (enrollmentAvailableChoices && enrollmentAvailableChoices.isEnrolled) {
      return (
        <div className={elClassName}>
          <button className="primary" type="button" disabled>
            {_t('Enrolled')}
          </button>
        </div>
      );
    } else {
      return (
        <div className={elClassName}>
          <TrackedA
            trackingName="legacy_course_enroll_button"
            data={{ courseId: course.id }}
            href={`/learn/${course.slug}?action=enroll`}
            className="link-button primary"
          >
            {_t('Enroll')}
          </TrackedA>
        </div>
      );
    }
  }
}

export default compose<PropsToComponent, PropsFromCaller>(
  withEnrollment<PropsFromCaller>(),
  Naptime.createContainer<PropsFromNaptime, PropsFromCaller>(({ courseId }) => ({
    course: CoursesV1.get(courseId, {
      fields: [
        'slug',
        // TODO: DLE Naptime ignore upstream courses.v1 requests with different params.
        // This is the first course.v1 call that naptime makes in ondemand app.
        's12nIds',
      ],
      params: { showHidden: true },
    }),
  }))
)(LegacyCourseEnrollButton);
